export default __webpack_public_path__ + "static/media/room2-MASK-industrial.11d69101.png";